import api from "../config/api";
import { Project } from "../types/Project";

const API_URL = "/project";

export const getProjects = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getProjectById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const createProject = (data: Project) => api.post(`${API_URL}/`, data);

export const updateProject = (id: number, data: Project) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteProject = (id: number) => api.delete(`${API_URL}/?id=${id}`);
